import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectIsTicketsLoading,
  selectTicketsPagination,
  selectMyTicketsFilters,
} from "../redux/selector";
import { actions } from "../redux/slice";

export const useMyTicketsTable = () => {
  // Filters should be collapsed by default on the Home My Tickets widget.
  const [isFiltersVisible, setIsFiltersVisible] = useState(false);
  const dispatch = useDispatch();

  const isLoading = useSelector(selectIsTicketsLoading);
  const pagination = useSelector(selectTicketsPagination);
  const filters = useSelector(selectMyTicketsFilters);

  const hasMore = pagination?.page < pagination?.totalPage;

  const toggleFiltersVisibility = () => {
    setIsFiltersVisible((prev) => !prev);
  };

  const handleLoadMore = () => {
    if (!isLoading && hasMore) {
      dispatch(
        actions.setTicketsPagination({
          ...pagination,
          page: pagination.page + 1,
        }),
      );
      dispatch(actions.getMyTickets());
    }
  };

  const handleFilterChange = (key: keyof typeof filters, value: any) => {
    const newFilters = { ...filters, [key]: value };
    dispatch(actions.setMyTicketsFilters(newFilters));
    dispatch(actions.setTicketsPagination({ ...pagination, page: 1 }));
    dispatch(actions.getMyTickets());
  };

  return {
    isFiltersVisible,
    toggleFiltersVisibility,
    hasMore,
    isLoading,
    onLoadMore: handleLoadMore,
    filters,
    onFilterChange: handleFilterChange,
  };
};
